import { createSelector } from 'reselect';
const getUrlQueryInformation = (state) => state.url;
export const getUrlQueryInformationState = createSelector([getUrlQueryInformation], (queryInformation) => queryInformation);
export const makeGetUrlQueryInformationState = () => createSelector([getUrlQueryInformationState], (queryInformation) => queryInformation);
export const makeGetUrlInformationPageSize = () => createSelector([getUrlQueryInformationState], (queryInformation) => queryInformation.size);
export const makeGetUrlInformationSearch = () => createSelector([getUrlQueryInformationState], (queryInformation) => queryInformation.q);
export const makeGetUrlFilters = () => createSelector([getUrlQueryInformationState], (queryInformation) => ({
    defaultFilter: queryInformation.defaultFilter,
    filter: queryInformation.filter,
}));
export const makeGetSearchTerm = () => createSelector([getUrlQueryInformationState], (queryInformation) => queryInformation.searchTerm);
export const makeGetStoreId = () => createSelector([getUrlQueryInformationState], (queryInformation) => queryInformation.storeId);
